"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderWolfEditCarExcessExplained = exports.renderWolfExcessExplained = exports.renderVoluntaryExcessExplained = exports.renderCompulsoryExcessExplained = void 0;
var React = require("react");
var renderExcessTable = function (excesses, excessType) { return (React.createElement("table", { className: "table table-responsive table-striped excess-table ".concat(excessType) },
    React.createElement("thead", null,
        React.createElement("tr", null,
            React.createElement("th", { scope: "col" }),
            React.createElement("th", { scope: "col" }, "Voluntary excess"),
            React.createElement("th", { scope: "col" }, "Compulsory excess"),
            React.createElement("th", { scope: "col" }, "Total"))),
    React.createElement("tbody", null,
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Fire"),
            React.createElement("td", null,
                "\u00A3",
                excesses.voluntaryExcess),
            React.createElement("td", null,
                "\u00A3",
                excesses.fireExcess),
            React.createElement("td", null,
                "\u00A3",
                excesses.totalFire)),
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Theft"),
            React.createElement("td", null,
                "\u00A3",
                excesses.voluntaryExcess),
            React.createElement("td", null,
                "\u00A3",
                excesses.theftExcess),
            React.createElement("td", null,
                "\u00A3",
                excesses.totalTheft)),
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Accidental damage"),
            React.createElement("td", null,
                "\u00A3",
                excesses.voluntaryExcess),
            React.createElement("td", null,
                "\u00A3",
                excesses.adExcess),
            React.createElement("td", null,
                "\u00A3",
                excesses.totalAd)),
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Glass replacement"),
            React.createElement("td", null, "-"),
            React.createElement("td", null,
                "\u00A3",
                excesses.windscreenReplacementExcess),
            React.createElement("td", null,
                "\u00A3",
                excesses.windscreenReplacementExcess)),
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Glass repair"),
            React.createElement("td", null, "-"),
            React.createElement("td", null,
                "\u00A3",
                excesses.windscreenRepairExcess),
            React.createElement("td", null,
                "\u00A3",
                excesses.windscreenRepairExcess))))); };
var renderWolfExcessTableExplained = function (excesses, excessType) { return (React.createElement("table", { className: "table table-responsive table-striped excess-table ".concat(excessType) },
    React.createElement("thead", null,
        React.createElement("tr", null,
            React.createElement("th", { scope: "col" }),
            React.createElement("th", { scope: "col" }, "Compulsory excess"),
            React.createElement("th", { scope: "col" }, "Voluntary excess"),
            React.createElement("th", { scope: "col" }, "Total"))),
    React.createElement("tbody", null,
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Fire"),
            React.createElement("td", null, "\u00A3".concat(excesses.fireExcess, "*")),
            React.createElement("td", null,
                "\u00A3",
                excesses.voluntaryExcess),
            React.createElement("td", null,
                "\u00A3",
                excesses.totalFire)),
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Theft"),
            React.createElement("td", null, "\u00A3".concat(excesses.theftExcess, "*")),
            React.createElement("td", null,
                "\u00A3",
                excesses.voluntaryExcess),
            React.createElement("td", null,
                "\u00A3",
                excesses.totalTheft)),
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Accidental damage"),
            React.createElement("td", null, "\u00A3".concat(excesses.adExcess, "*")),
            React.createElement("td", null,
                "\u00A3",
                excesses.voluntaryExcess),
            React.createElement("td", null,
                "\u00A3",
                excesses.totalAd)),
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Glass replacement"),
            React.createElement("td", null,
                "\u00A3",
                excesses.windscreenReplacementExcess),
            React.createElement("td", null, "-"),
            React.createElement("td", null,
                "\u00A3",
                excesses.windscreenReplacementExcess)),
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Glass repair"),
            React.createElement("td", null,
                "\u00A3",
                excesses.windscreenRepairExcess),
            React.createElement("td", null, "-"),
            React.createElement("td", null,
                "\u00A3",
                excesses.windscreenRepairExcess))))); };
var renderWolfExcessTable = function (excesses) { return (React.createElement("table", { className: "table table-responsive table-striped excess-table compulsory" },
    React.createElement("thead", null,
        React.createElement("tr", null,
            React.createElement("th", { scope: "col" }),
            React.createElement("th", { scope: "col" }, "Compulsory excess"),
            React.createElement("th", { scope: "col" }, "Voluntary excess"),
            React.createElement("th", { scope: "col" }, "Total"))),
    React.createElement("tbody", null,
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Fire"),
            React.createElement("td", null,
                "\u00A3",
                excesses.fireExcess,
                "*"),
            React.createElement("td", null,
                "\u00A3",
                excesses.voluntaryExcess,
                "**"),
            React.createElement("td", null,
                "\u00A3",
                excesses.totalFire)),
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Theft"),
            React.createElement("td", null,
                "\u00A3",
                excesses.theftExcess,
                "*"),
            React.createElement("td", null,
                "\u00A3",
                excesses.voluntaryExcess,
                "**"),
            React.createElement("td", null,
                "\u00A3",
                excesses.totalTheft)),
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Accidental damage"),
            React.createElement("td", null,
                "\u00A3",
                excesses.adExcess,
                "*"),
            React.createElement("td", null,
                "\u00A3",
                excesses.voluntaryExcess,
                "**"),
            React.createElement("td", null,
                "\u00A3",
                excesses.totalAd)),
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Glass replacement"),
            React.createElement("td", null,
                "\u00A3",
                excesses.windscreenReplacementExcess),
            React.createElement("td", null, "-"),
            React.createElement("td", null,
                "\u00A3",
                excesses.windscreenReplacementExcess)),
        React.createElement("tr", null,
            React.createElement("td", { className: "font-weight-semi-bold" }, "Glass repair"),
            React.createElement("td", null,
                "\u00A3",
                excesses.windscreenRepairExcess),
            React.createElement("td", null, "-"),
            React.createElement("td", null,
                "\u00A3",
                excesses.windscreenRepairExcess))))); };
var renderCompulsoryExcessExplained = function (excesses) { return (React.createElement(React.Fragment, null,
    React.createElement("p", { className: "font-weight-extra-light mb-4" },
        React.createElement("span", { className: "font-weight-semi-bold text-blue-2" }, "Compulsory"),
        " excess it's a fixed excess, set by us, ",
        React.createElement("span", { className: "font-weight-semi-bold" }, "it's the amount you'll have to pay if you make a claim"),
        ".",
        " ",
        "The amount varies depending on your circumstances."),
    renderExcessTable(excesses, "compulsory"),
    React.createElement("p", { className: "font-weight-extra-light mb-4" }, "For example, choosing a \u00A3500 total excess(compulsory + voluntary) means that if you file a claim for \u00A34,000 and it's approved, we will pay you \u00A33,500."),
    React.createElement("p", { className: "font-weight-extra-light mb-4" },
        "Non using an LV= recommended repairer? You'll pay an ",
        React.createElement("span", { className: "font-weight-semi-bold" },
            "extra ", "\u00A3".concat(excesses.nonRecommendedRepairerExcess),
            " excess"),
        "."))); };
exports.renderCompulsoryExcessExplained = renderCompulsoryExcessExplained;
var renderVoluntaryExcessExplained = function (excesses) { return (React.createElement(React.Fragment, null,
    React.createElement("p", { className: "font-weight-extra-light mb-4" },
        React.createElement("span", { className: "font-weight-semi-bold text-blue-2" }, "Voluntary excess"),
        " is the",
        " ",
        React.createElement("span", { className: "font-weight-semi-bold" }, "amount that you agree to pay, in addition to your compulsory excess, if you make a claim"),
        ". People agree to a voluntary excess in return for a lower premium."),
    renderExcessTable(excesses, "voluntary"),
    React.createElement("p", { className: "font-weight-extra-light mb-4" }, "For example, choosing a \u00A3500 total excess(compulsory + voluntary) means that if you file a claim for \u00A34,000 and it's approved, we will pay you \u00A33,500."),
    React.createElement("p", { className: "font-weight-extra-light mb-4" },
        "Non using an LV= recommended repairer? You'll pay an ",
        React.createElement("span", { className: "font-weight-semi-bold" },
            "extra ", "\u00A3".concat(excesses.nonRecommendedRepairerExcess),
            " excess"),
        "."))); };
exports.renderVoluntaryExcessExplained = renderVoluntaryExcessExplained;
var renderWolfExcessExplained = function (excesses) {
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "font-weight-extra-light mb-4" }, "An excess is the amount you pay towards any claim you make."),
        React.createElement("p", { className: "font-weight-extra-light mb-4" }, "You can choose your own voluntary excess but you\u2019ll have to pay the compulsory excess we apply for any accidental damage, fire or theft. See an example below."),
        renderWolfExcessTable(excesses),
        React.createElement("p", { className: "font-weight-extra-light mb-4" },
            "* If you decide to use your own repairer rather than one we\u2019ve recommended, an additional \u00A3",
            excesses.nonRecommendedRepairerExcess,
            " excess will be applied to your total excess (compulsory + voluntary)."),
        React.createElement("p", { className: "font-weight-extra-light" }, "** You choose the amount of voluntary excess you\u2019ll pay towards a claim - from \u00A30 up to \u00A3500.")));
};
exports.renderWolfExcessExplained = renderWolfExcessExplained;
var renderWolfEditCarExcessExplained = function (excesses) { return (React.createElement(React.Fragment, null,
    React.createElement("p", { className: "font-weight-extra-light mb-4" }, "An excess is the amount you pay towards any claim you make."),
    React.createElement("p", { className: "font-weight-extra-light mb-4" },
        "You have \u00A3",
        excesses.voluntaryExcess,
        " voluntary excess and \u00A3",
        excesses.adExcess,
        " compulsory excess for any accidental damage, fire or theft. See an example below."),
    renderWolfExcessTableExplained(excesses, "compulsory"),
    React.createElement("p", { className: "font-weight-extra-light mb-4" },
        "* If you decide to use your own repairer rather than one we have recommended then an additional \u00A3",
        excesses.nonRecommendedRepairerExcess,
        " excess will be applied to your total excess (compulsory + voluntary)"))); };
exports.renderWolfEditCarExcessExplained = renderWolfEditCarExcessExplained;
//# sourceMappingURL=ExcessExplainedRenderers.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/modals/renderers/ExcessExplainedRenderers.js
// module id = 227
// module chunks = 0